import { SupportedCountries } from "@/hooks/use-state-list";
import { Divider, NativeSelect } from "@mui/material";
import { CountryCode, getCountries } from "libphonenumber-js";
import { useMemo } from "react";

interface CountryCodeSelectorProps {
  countryCode: CountryCode;
  onSelect: (countryCode: CountryCode) => void;
}

export const CountryCodeSelector = ({ countryCode, onSelect }: CountryCodeSelectorProps) => {
  const { priorityCountries, otherCountries } = useMemo(() => {
    const supported: string[] = Object.keys(SupportedCountries);;
    const notSupported: string[] = [];
    getCountries().forEach((country) => {
      if (!supported.includes(country)) {
        notSupported.push(country);
      }
    });
    
    return { priorityCountries: supported, otherCountries: notSupported };
  }, []);

  return (
    <NativeSelect
      value={countryCode}
      onChange={(event) => onSelect(event.target.value as CountryCode)}
      sx={{
        "& .MuiNativeSelect-select": {
          width: "40px",
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
        "&:before, &:after": {
          borderBottom: "none",
        },
        "&:hover:before": {
          borderBottom: "none !important",
        },
      }}
    >
      {priorityCountries.map((supportedCountry) => (
        <option key={supportedCountry} value={supportedCountry}>
          {supportedCountry}
        </option>
      ))}
      <Divider />
      {otherCountries.map((otherCountry) => (
        <option key={otherCountry} value={otherCountry}>
          {otherCountry}
        </option>
      ))}
    </NativeSelect>
  );
};
